import React from 'react';
import styles from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const AddOverlay = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { addButtonMenu, title } = props;
  return (
    <div className={styles.addButtonOverlay}>
      <div className={styles.addButtonTitle}>
        {title || getI18n('general.addProducts')}
      </div>
      <div className={styles.addButtonAll}>
        {addButtonMenu.map((list) => {
          const { onClick } = list;
          return (
            <div
              key={list.key}
              className={styles.addButtonList}
              onClick={onClick}>
              <p className={styles.addButtonLinkTitle}>{list.name}</p>
              <p className={styles.addButtonLinkDescription}>
                {list.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default AddOverlay;
